'use strict';

var formValidation = require('base:components/formValidation');
var dynamicModal = require('./dynamicModal');

let $cache = {
    rxContainer: $('#rx-container'),
    sections: $('.rx-form-section'),
    section1: $('.rx-form-section[data-step="1"]'),
    section2: $('.rx-form-section[data-step="2"]'),
    section3: $('.rx-form-section[data-step="3"]'),
    form: $('#rxForm'),
    pdWidgetWrapper: $(".msrt-wrapper"),
    pdWidget: $('#msrt-container'),
    vtoWidget: $('#VTOWidget'),
    pdResultInput: $('#dwfrm_rxForm_pupillaryDistance'),
    frameProductId: $('input[name="dwfrm_rxForm_productID"]'),
    nav: $('.rx-stepper'),
    helpSection: $('.js-help-section'),
    helpBtn: $('.js-help-btn')
};

const NB_STAGES = 4;

/**
 * open a new section and close the previous one
 * @param {string|integer} stepNumber - current step to open
 */
function openSection(stepNumber) {
    var $others = $('.rx-form-section:not([data-step="' + stepNumber + '"])');
    $others.removeClass('active').hide();
    $cache['section' + stepNumber].show().addClass('active');
    $cache.rxContainer.attr('data-current-step', stepNumber);
    handleNavigation(stepNumber);

    let $stepBanner = $(`.js-hero-banner[data-step="${stepNumber}"]`);
    let $otherBanners = $(`.js-hero-banner:not([data-step="${stepNumber}"])`);
    $otherBanners.animate({
        height: "0px"
    }, 300);
    setTimeout(function () {
        $otherBanners.addClass('d-none');
    }, 300);
    if ($stepBanner.length) {
        $stepBanner.css({
            height: "auto"
        });
        setTimeout(function () {
            $stepBanner.show();
            $stepBanner.removeClass('d-none');
        }, 300);
    }
}

/**
 * Launch Pupillary Distance Widget
 * @param {*} $currentSection - context node element
 */
function launchMsrt($currentSection) {
    let triggerHelpAfterDuration = true;
    $cache.pdWidgetWrapper.show();
    const params = {
        apiKey: $cache.pdWidget.attr('data-api-key'),
        ...(JSON.parse($cache.pdWidget.attr('data-theme-config') || {})),
    };
    const $nextBtn = $('.js-next-btn', $currentSection);
    const $launchPDBtn = $('.js-launch-pd');
    const $resultWrapper = $('.js-pd-result-wrapper');

    $nextBtn.addClass('disabled');
    $('body').addClass('modal-open');
    $('.js-error-pd-missing', $currentSection).addClass('d-none');


    setTimeout(function () {
        if (triggerHelpAfterDuration) {
            $cache.helpBtn.click();
        }
    }, 1000 * 60 * 2) // 2 minutes

    window.closeMsrt = function () {
        triggerHelpAfterDuration = false;
        $cache.pdWidgetWrapper.hide();
        $cache.pdWidget.html('');
        $('body').removeClass('modal-open');
        if ($cache.pdResultInput.val()) {
            $resultWrapper.removeClass('d-none');
            $nextBtn.removeClass('disabled');
            $launchPDBtn.addClass('d-none');
        } else {
            $resultWrapper.addClass('d-none');
            $nextBtn.addClass('disabled');
            $launchPDBtn.removeClass('d-none');
        }
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    };

    Msrt.createWidget("msrt-container", Object.assign({}, params, {
        onGetResultPd: (result) => {
            let pdValue = result.pd;
            if (result.left && result.right) {
                pdValue += '|' + result.left + '|' + result.right;
            }
            $('body').trigger('rxForm:PDResultReceived', [pdValue]);
        },
        onTooManyErrors: () => { console.log('Errors PD widget'); closeMsrt(); },
        onClose: () => {
            window.closeMsrt();
        }
    }));
};

/**
 * Init events of section 1
 * @returns {Promise} promise
 */
function initSection1() {
    return new Promise((resolve, reject) => {
        const SECTION_STEP = 1;
        let $currentSection = $cache.section1;
        const $nextBtn = $('.js-next-btn', $currentSection);
        const $launchPDBtn = $('.js-launch-pd');
        const $setSubStepBtn = $('.js-pd-set-sub-step', $currentSection);
        const $nextSubStepBtn = $('.js-pd-next-sub-step', $currentSection);
        const $pdManualCheckbox = $('.js-pd-input-double-checkbox', $currentSection);
        const $backBtn = $('.js-back-btn', $currentSection);

        openSection(SECTION_STEP);
        if ($cache.pdResultInput.val()) {
            $nextBtn.removeClass('disabled');
        }
        $launchPDBtn.off('click').on('click', function () {
            launchMsrt($currentSection);
            window.dataLayer.push({
                event: 'MesurePupille'
            });
        });
        $('.msrt-overlay', $currentSection).off('click').on('click', function () {
            window.closeMsrt();
        });
        $nextBtn.on('click', function () {
            const $errorBox = $('.js-error-pd-validation', $currentSection);
            $errorBox.addClass('d-none').text('');
        
            if ($(this).hasClass('disabled')) {
                $('.js-error-pd-missing', $currentSection).removeClass('d-none');
                return;
            }
        
            const isDouble = $pdManualCheckbox.is(':checked');
            const pdMin = window.app.preferences.pdMinValue;
            const pdMax = window.app.preferences.pdMaxValue;
            const eyeMin = pdMin / 2;
            const eyeMax = pdMax / 2;
        
            let errorMessage = '';
        
            if (isDouble) {
                const left = parseFloat($('[name="pd-value-left"]', $currentSection).val());
                const right = parseFloat($('[name="pd-value-right"]', $currentSection).val());
        
                if (isNaN(left) || isNaN(right)) return;
        
                const total = left + right;
                const diff = Math.abs(left - right);
        
                const leftInvalid = left < eyeMin || left > eyeMax;
                const rightInvalid = right < eyeMin || right > eyeMax;
        
                if (leftInvalid && !rightInvalid) {
                    errorMessage = $errorBox.data('msg-left').replace('{0}', eyeMin).replace('{1}', eyeMax);
                } else if (rightInvalid && !leftInvalid) {
                    errorMessage = $errorBox.data('msg-right').replace('{0}', eyeMin).replace('{1}', eyeMax);
                } else if (leftInvalid && rightInvalid) {
                    errorMessage = $errorBox.data('msg-both').replace('{0}', eyeMin).replace('{1}', eyeMax);
                } else if (total < pdMin || total > pdMax) {
                    errorMessage = $errorBox.data('msg-single').replace('{0}', pdMin).replace('{1}', pdMax);
                } else if (diff > 5) {
                    errorMessage = $errorBox.data('msg-diff');
                }
        
            } else {
                const pd = parseFloat($('[name="pd-value"]', $currentSection).val());
                if (!isNaN(pd) && (pd < pdMin || pd > pdMax)) {
                    errorMessage = $errorBox.data('msg-single').replace('{0}', pdMin).replace('{1}', pdMax);
                }
            }
        
            if (errorMessage) {
                $errorBox.text(errorMessage).removeClass('d-none');
                return false;
            }
        });        
        
        $setSubStepBtn.on('click', function () {
            const pdMode = $(this).attr('data-pd-mode');

            $('.js-pd-pane-sub-section', $currentSection).addClass('d-none');
            $(`.js-pd-pane-sub-section[data-sub-step="2"][data-pd-mode="${pdMode}"]`, $currentSection).removeClass('d-none');
            $('.js-launch-pd').removeClass('d-none');
        });
        $pdManualCheckbox.on('change', function () {
            $('.js-pd-manual-value-container', $currentSection).addClass('d-none').find('.js-pd-manual-input').val('');
            window.savePDValue(null);
            if ($(this).is(':checked')) {
                $('.js-pd-manual-value-container[data-type="double"]', $currentSection).removeClass('d-none');
            } else {
                $('.js-pd-manual-value-container[data-type="single"]', $currentSection).removeClass('d-none');
            }
        });

        function savePDValue(pdValue) {
            const $launchPDBtn = $('.js-launch-pd');

            var $jsCustomerPDContainer = $('.js-customer-pd');
            
            const mesureUnit = $jsCustomerPDContainer.last().attr('data-mesure-unit');
            const labelRight = $jsCustomerPDContainer.last().attr('data-label-right');
            const labelLeft = $jsCustomerPDContainer.last().attr('data-label-left');

            let formattedHtml = '';

            // Split the pdValue into its components
            if (pdValue) {
                const values = pdValue.toString().split('|');

                // Check the number of values and construct the formatted string accordingly
                if (values.length === 3) {
                    formattedHtml = `${labelRight}: ${values[2]} ${mesureUnit}, ${labelLeft}: ${values[1]} ${mesureUnit}`;
                } else if (values.length === 2) {
                    formattedHtml = `${labelRight}: ${values[1]} ${mesureUnit}, ${labelLeft}: ${values[0]} ${mesureUnit}`;
                } else if (values.length === 1) {
                    formattedHtml = `${values[0]}  ${mesureUnit}`;
                }
            }
            $jsCustomerPDContainer.html(formattedHtml);

            $cache.pdResultInput.val(pdValue);

            if (pdValue) {

                $nextBtn.removeClass('disabled');
                $launchPDBtn.addClass('d-none');
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
            } else {
                $nextBtn.addClass('disabled');
                $launchPDBtn.removeClass('d-none');
            }
        }
        window.savePDValue = savePDValue;

        $('.js-pd-manual-input', $currentSection).on('change, keyup', function () {
            let name = $(this).attr('name');
            let value = parseFloat($(this).val());
            let finalValue = value;

            if (isNaN(value)) {
                finalValue = '';
            } else {
                if (name === 'pd-value') {
                    finalValue = value;
                } else {
                    let right = $('.js-pd-manual-input[name="pd-value-right"]', $currentSection).val();
                    let left = $('.js-pd-manual-input[name="pd-value-left"]', $currentSection).val();
                    finalValue = left && right ? left + '|' + right : '';
                }
            }
            window.savePDValue(finalValue ? [finalValue] : null);
        });

        function PDResultReceived(e, pdValue) {
            window.savePDValue(pdValue);
            window.closeMsrt();
        };
        $('body').on('rxForm:PDResultReceived', PDResultReceived);
        return resolve();
    });
}

function initRxFilters($currentSection) {
    var $filtersWrapper = $('.js-rx-filters-wrapper', $currentSection);
    if (!$filtersWrapper.length) {
        return;
    }
    $filtersWrapper.addClass('refinement-bar-closed');

    var $activeFilters = $('.js-rx-active-filters', $currentSection);
    var $checkboxes = $('.js-rx-filter-checkbox', $currentSection);
    var resetLabel = $('.js-rx-reset-filters', $currentSection).first().text().trim() || 'Reset';

    function isMobile() {
        return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    }

    function getSelectedFilters() {
        var filters = {};
        $checkboxes.filter(':checked').each(function () {
            var attrId = $(this).data('attribute');
            var value = $(this).data('value');
            if (!filters[attrId]) {
                filters[attrId] = [];
            }
            filters[attrId].push(String(value));
        });
        return filters;
    }

    function getTileValues($tile, attrId) {
        var attrKey = String(attrId).toLowerCase();
        var rawValues = $tile.attr('data-filter-' + attrKey);
        if (!rawValues) {
            return [];
        }
        return String(rawValues).split('|').map(function (value) {
            return value.toLowerCase();
        });
    }

    function tileMatchesFilters($tile, filters, ignoreAttrId) {
        var filterKeys = Object.keys(filters);
        if (filterKeys.length === 0) {
            return true;
        }

        return filterKeys.every(function (attrId) {
            if (ignoreAttrId && String(attrId) === String(ignoreAttrId)) {
                return true;
            }
            var tileValues = getTileValues($tile, attrId);
            if (!tileValues.length) {
                return false;
            }
            var selectedValues = filters[attrId].map(function (value) {
                return String(value).toLowerCase();
            });
            return selectedValues.some(function (value) {
                return tileValues.indexOf(value) > -1;
            });
        });
    }

    function updateFilterOptions(filters) {
        var availableValues = {};
        var allAttributes = [];

        $checkboxes.each(function () {
            var attrId = $(this).data('attribute');
            if (attrId && allAttributes.indexOf(attrId) === -1) {
                allAttributes.push(attrId);
                availableValues[attrId] = {};
            }
        });

        $('.rx-product-tile', $currentSection).each(function () {
            var $tile = $(this);
            allAttributes.forEach(function (attrId) {
                if (!tileMatchesFilters($tile, filters)) {
                    return;
                }
                var tileValues = getTileValues($tile, attrId);
                tileValues.forEach(function (value) {
                    if (value) {
                        availableValues[attrId][value] = true;
                    }
                });
            });
        });

        $checkboxes.each(function () {
            var $checkbox = $(this);
            var attrId = $checkbox.data('attribute');
            var value = String($checkbox.data('value') || '').toLowerCase();
            var isSelected = $checkbox.is(':checked');
            var isAvailable = availableValues[attrId] && availableValues[attrId][value];
            var $item = $checkbox.closest('li');

            if (isSelected || isAvailable) {
                $item.removeClass('d-none');
            } else {
                $item.addClass('d-none');
            }
        });
    }

    function updateActiveFilters(filters) {
        if (!$activeFilters.length) {
            return;
        }

        $activeFilters.empty();
        var hasFilters = false;

        Object.keys(filters).forEach(function (attrId) {
            filters[attrId].forEach(function (value) {
                var $checkbox = $checkboxes.filter('[data-attribute="' + attrId + '"][data-value="' + value + '"]');
                var label = $checkbox.data('displayValue') || $checkbox.attr('data-display-value') || value;
                var $button = $('<button type="button" class="btn btn-link text-reset text-decoration-none text-capitalize js-rx-remove-filter"></button>');

                $button.attr('data-attribute', attrId);
                $button.attr('data-value', value);
                $button.append($('<span class="mr-2" aria-hidden="true"></span>').text(label));
                $button.append('<i class="icon-close"></i>');

                $activeFilters.append($('<li class="filter-value"></li>').append($button));
                hasFilters = true;
            });
        });

        if (hasFilters) {
            $activeFilters.append(
                $('<li class="filter-reset"></li>').append(
                    $('<button type="button" class="btn js-rx-reset-filters"></button>').text(resetLabel)
                )
            );
        }
    }

    function applyFilters() {
        var filters = getSelectedFilters();
        $('.rx-product-tile', $currentSection).each(function () {
            var $tile = $(this);
            var shouldShow = tileMatchesFilters($tile, filters);
            $tile.data('rx-should-show', shouldShow);

            if (shouldShow) {
                $tile.removeClass('d-none');
                // allow next frame to trigger transition
                window.requestAnimationFrame(function () {
                    $tile.removeClass('rx-filtered-out');
                });
            } else {
                $tile.addClass('rx-filtered-out');
                window.setTimeout(function () {
                    if ($tile.data('rx-should-show') === false) {
                        $tile.addClass('d-none');
                    }
                }, 250);
            }
        });
        updateFilterOptions(filters);
        updateActiveFilters(filters);
    }

    $filtersWrapper.off('click', '.js-rx-toggle-filters').on('click', '.js-rx-toggle-filters', function (e) {
        e.preventDefault();
        if (isMobile()) {
            $('body').addClass('mobile-refinement-bar-open');
        } else {
            $filtersWrapper.toggleClass('refinement-bar-closed');
            $('.refinement-bar-toggle', $filtersWrapper).toggleClass('refinement-bar-closed');
        }
    });

    $filtersWrapper.off('click', '.refinement-bar button.close').on('click', '.refinement-bar button.close', function (e) {
        e.preventDefault();
        $('body').removeClass('mobile-refinement-bar-open');
    });

    $filtersWrapper.off('click', '.js-rx-apply-filters').on('click', '.js-rx-apply-filters', function (e) {
        e.preventDefault();
        applyFilters();
        $('body').removeClass('mobile-refinement-bar-open');
    });

    $filtersWrapper.off('click', '.js-rx-reset-filters').on('click', '.js-rx-reset-filters', function (e) {
        e.preventDefault();
        $checkboxes.prop('checked', false);
        applyFilters();
        $('body').removeClass('mobile-refinement-bar-open');
    });

    $filtersWrapper.off('click', '.js-rx-remove-filter').on('click', '.js-rx-remove-filter', function (e) {
        e.preventDefault();
        var attrId = $(this).data('attribute');
        var value = $(this).data('value');
        $checkboxes
            .filter('[data-attribute="' + attrId + '"][data-value="' + value + '"]')
            .prop('checked', false);
        applyFilters();
    });

    $checkboxes.off('change.rxFilters').on('change.rxFilters', function () {
        applyFilters();
    });

    applyFilters();
}


/**
 * Init events of section 2
 * @returns {Promise} promise
 */
function initSection2() {
    return new Promise((resolve, reject) => {
        const SECTION_STEP = 2;
        let $currentSection = $cache.section2;
        openSection(SECTION_STEP);
        const $fitmix = $cache.vtoWidget;
        const $vtoModal = $('#rx-VTO-modal', $currentSection);
        const productCarouselSelector = '.carousel';
        const $nextBtn = $('.js-next-btn[data-next-step="3"]', $currentSection);
        const $lensTypeSection = $('.js-lens-type-section', $currentSection);
        const $frameGridSection = $('.js-frame-grid-section', $currentSection);
        window.dataLayer.push({
            'event': 'Etape1'
        });

        /**
         * Check whether all three choices (prescription type, lens type, frame) are made
         * and toggle the next button accordingly.
         */
        function checkNextButtonState() {
            var frameSelected = !!$cache.frameProductId.val();
            var prescriptionInput = $('input[name="dwfrm_rxForm_prescriptionType"]', $currentSection);
            var lensInput = $('input[name="dwfrm_rxForm_lens"]', $currentSection);
            var prescriptionOk = !prescriptionInput.length || prescriptionInput.filter(':checked').length > 0;
            var lensOk = !lensInput.length || lensInput.filter(':checked').length > 0;
            if (frameSelected && prescriptionOk && lensOk) {
                $nextBtn.removeClass('disabled');
            } else {
                $nextBtn.addClass('disabled');
            }
        }

        /**
         * Reset frame selection hidden inputs, tile highlight and recap.
         */
        function clearFrameSelection() {
            $cache.frameProductId.val('');
            $('input[name="dwfrm_rxForm_productSKU"]').val('');
            $('input[name="dwfrm_rxForm_productColor"]').val('');
            $('input[name="dwfrm_rxForm_productSize"]').val('');
            $('.rx-product-tile', $currentSection).removeClass('selected');
            $('.js-frame-result-wrapper').addClass('d-none');
            $('.js-frame-base-warning', $currentSection).addClass('d-none').empty();
            $nextBtn.addClass('disabled');
        }

        /**
         * Show or hide the base warning depending on the selected frame's base vs. the site-pref limit.
         * @param {jQuery} $productInfoEl - the .js-product-info element carrying data-base-value
         */
        function updateFrameBaseWarning($productInfoEl) {
            var $warning = $('.js-frame-base-warning', $currentSection);
            if (!$warning.length) return;

            var limitAttr = $warning.data('base-limit');
            var baseLimit = parseFloat(limitAttr);
            if (!limitAttr || isNaN(baseLimit)) {
                return;
            }

            var baseValue = parseFloat($productInfoEl.attr('data-base-value'));
            if (isNaN(baseValue)) {
                $warning.addClass('d-none').empty();
                return;
            }

            if (baseValue >= baseLimit) {
                var message = ($warning.data('warning-template') || '').replace(/\{0\}/g, baseValue);
                $warning.html(message).removeClass('d-none');
            } else {
                $warning.addClass('d-none').empty();
            }
        }

        /**
         * Filter product tiles by both prescription type (data-prescription-type) and lens type
         * (data-lens-type) using AND logic — a tile must satisfy both active selections to remain
         * visible. Tiles with no attribute value are always shown for that filter (fallback).
         * Shows a no-results message when all tiles are filtered out.
         */
        function applyFrameFilters() {
            var selectedLens = $('input[name="dwfrm_rxForm_lens"]:checked', $currentSection).val();
            var selectedPrescription = $('input[name="dwfrm_rxForm_prescriptionType"]:checked', $currentSection).val();
            var $productGrid = $('.js-product-grid', $currentSection);
            if (!$productGrid.length) {
                return Promise.resolve();
            }

            var selectedLensNormalized = selectedLens ? String(selectedLens).toLowerCase() : null;
            var selectedPrescriptionNormalized = selectedPrescription ? String(selectedPrescription).toLowerCase() : null;

            var $overlay = $('.rx-grid-loading-overlay', $productGrid);
            if (!$overlay.length) {
                $overlay = $('<div class="rx-grid-loading-overlay" aria-hidden="true"><div class="rx-grid-loading-spinner"></div></div>');
                $productGrid.append($overlay);
            }

            $productGrid.addClass('is-loading');

            return new Promise(function (resolve) {
                window.requestAnimationFrame(function () {
                    window.requestAnimationFrame(function () {
                        var $matched = $();
                        var $unmatched = $();

                        $('.rx-product-tile', $currentSection).each(function () {
                            var $tile = $(this);

                            var matchesLens = true;
                            if (selectedLensNormalized) {
                                var lensArr = ($tile.attr('data-lens-type') || '').split('|').filter(Boolean).map(function (v) { return v.toLowerCase(); });
                                matchesLens = lensArr.length === 0 || lensArr.indexOf(selectedLensNormalized) > -1;
                            }

                            var matchesPrescription = true;
                            if (selectedPrescriptionNormalized) {
                                var prescriptionArr = ($tile.attr('data-prescription-type') || '').split('|').filter(Boolean).map(function (v) { return v.toLowerCase(); });
                                matchesPrescription = prescriptionArr.length === 0 || prescriptionArr.indexOf(selectedPrescriptionNormalized) > -1;
                            }

                            if (matchesLens && matchesPrescription) {
                                $matched = $matched.add($tile);
                                $tile.removeClass('d-none rx-filtered-out');
                            } else {
                                $unmatched = $unmatched.add($tile);
                                $tile.addClass('rx-filtered-out d-none');
                            }
                        });

                        // Matched tiles first
                        $matched.each(function () { $productGrid.append(this); });
                        $unmatched.each(function () { $productGrid.append(this); });

                        // Fade-in effect on visible tiles
                        $matched.each(function (idx) {
                            this.style.setProperty('--rx-tile-delay', (idx * 30) + 'ms');
                            this.classList.remove('rx-tile-animate-in');
                            void this.offsetWidth;
                            this.classList.add('rx-tile-animate-in');
                        });

                        var $noFramesMsg = $('.js-rx-no-frames-message', $currentSection);
                        if ($matched.length === 0) {
                            $noFramesMsg.removeClass('d-none');
                        } else {
                            $noFramesMsg.addClass('d-none');
                        }

                        setTimeout(function () {
                            $productGrid.removeClass('is-loading');
                            resolve();
                        }, 250);
                    });
                });
            });
        }

        // Scroll option to center of its horizontal scroll container
        function scrollOptionToCenterOfScrollX($option) {
            var $container = $option.closest('.form-group');
            if (!$container.length) { return; }
            var container = $container[0];
            var optionEl = $option[0];
            var scrollLeft = optionEl.offsetLeft - (container.clientWidth / 2) + (optionEl.offsetWidth / 2);
            scrollLeft = Math.max(0, Math.min(scrollLeft, container.scrollWidth - container.clientWidth));
            container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }

        // Progressive disclosure — Prescription type → reveal Lens type section
        // Also re-filters the frame grid if it is already visible (user changed their selection).
        $('input[name="dwfrm_rxForm_prescriptionType"]', $currentSection).on('change', function () {
            var $checkedInput = $(this);
            $lensTypeSection.removeClass('d-none');
            $('.js-prescription-type-result-wrapper').removeClass('d-none');
            $('.js-prescription-type-result').html($checkedInput.parent().find('label .title').html());
            $('.custom-radio', $currentSection).filter(':has(input[name="dwfrm_rxForm_prescriptionType"])').removeClass('is-invalid');
            checkNextButtonState();
            if (!$frameGridSection.hasClass('d-none')) {
                clearFrameSelection();
                applyFrameFilters();
            }
            setTimeout(function () {
                var $option = $checkedInput.closest('.custom-radio');
                if ($option.length) {
                    scrollOptionToCenterOfScrollX($option);
                }
                setTimeout(function () {
                    $lensTypeSection[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 100);
            }, 50);
        });

        // Progressive disclosure — Lens type → reveal Frame grid + filter + clear frame selection
        $('input[name="dwfrm_rxForm_lens"]', $currentSection).on('change', function () {
            var $checkedInput = $(this);
            $frameGridSection.removeClass('d-none');
            clearFrameSelection();
            $('.js-lens-result-wrapper').removeClass('d-none');
            $('.js-lens-result').html($checkedInput.parent().find('label .title').html());
            $('.custom-radio', $currentSection).filter(':has(input[name="dwfrm_rxForm_lens"])').removeClass('is-invalid');
            checkNextButtonState();
            setTimeout(function () {
                var $option = $checkedInput.closest('.custom-radio');
                if ($option.length) {
                    scrollOptionToCenterOfScrollX($option);
                }
                applyFrameFilters().then(function () {
                    $frameGridSection[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            }, 50);
        });

        // Auto-reveal lens section if prescription type was pre-checked (single option)
        if ($('input[name="dwfrm_rxForm_prescriptionType"]:checked', $currentSection).length) {
            $lensTypeSection.removeClass('d-none');
        }
        // Auto-reveal frame grid if lens type was pre-checked (single option)
        if ($('input[name="dwfrm_rxForm_lens"]:checked', $currentSection).length) {
            $frameGridSection.removeClass('d-none');
        }
        /**
         * open VTO module
         */
        function openVto() {
            window.fitmixInstance.startVto('live');
            $fitmix.show();
            $vtoModal.modal();
        }
        /**
         * stop VTO module
         */
        function stopVto() {
            window.fitmixInstance.stopVto();
        }
        $vtoModal.on('hide.bs.modal', function (e) {
            stopVto();
            $(productCarouselSelector, $vtoModal).slick('unslick');
        })
        $vtoModal.on('shown.bs.modal', function () {
            $(productCarouselSelector, $vtoModal).slick({
                rows: 0,
                dots: false,
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            dots: false,
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        })
        $('.js-stop-vto').off('click').on('click', function () {
            stopVto();
        });

        $.ajax({
            method: 'GET',
            url: $currentSection.attr('data-products-url'),
            success: function (htmlContent) {
                let $productGrid = $('.js-product-grid', $currentSection);
                let $modalBody = $('#rx-VTO-modal .modal-body');
                $productGrid.html(htmlContent);
                if ($('.js-product-carousel', $modalBody).length > 0) {
                    $('.js-product-carousel', $modalBody).remove();
                }
                $('.js-product-carousel', $productGrid).appendTo($modalBody);
                initRxFilters($currentSection);
                // Apply pre-filters (prescription type + lens type) if either was already auto-checked (single-option case)
                applyFrameFilters();

                function initVTOonItem($this) {
                    let vtoId = $this.attr('data-vto-id');
                    let productId = $this.attr('data-product-id');
                    // only change vto frame
                    window.fitmixInstance.setFrame(vtoId);

                    $('.js-select-frame', $vtoModal).attr('data-product-id', productId);

                    let slideSelector = '.rx-product-carousel-item';
                    let $carouselSlide = $this.closest(slideSelector);

                    $(slideSelector).removeClass('selected');
                    $carouselSlide.addClass('selected')

                    $('.js-select-fittingbox-variation', $vtoModal).removeClass('active');
                    $('.js-select-fittingbox-variation[data-product-id="' + productId + '"]', $carouselSlide).addClass('active');
                }

                $('.js-launch-vto').off('click').on('click', function () {
                    let $this = $(this);
                    let $productTile = $this.closest('.rx-product-tile');
                    let productId = $productTile.find('.js-select-frame').attr('data-product-id') || $productTile.attr('data-product-id');

                    openVto();
                    $(`.js-select-fittingbox-variation[data-product-id="${productId}"]`, $vtoModal).click();
                    initVTOonItem($(`.js-select-fittingbox[data-product-id="${productId}"]`, $vtoModal));
                    window.dataLayer.push({
                        event: 'EssaiMonture'
                    });
                });
                $('.js-select-fittingbox').off('click').on('click', function () {
                    initVTOonItem($(this));
                });
                $('.js-select-fittingbox-variation').off('click').on('click', function () {
                    let $this = $(this);
                    let $parent = $this.closest('.js-select-fittingbox');
                    $parent.attr('data-vto-id', $this.attr('data-vto-id'));
                    $parent.attr('data-product-id', $this.attr('data-product-id'));
                });

                let currentlySelectedProductID = $('input[name="dwfrm_rxForm_productID"]').val();
                if (currentlySelectedProductID) {
                    $('.js-product-info[data-product-id="' + currentlySelectedProductID + '"').closest('.rx-product-tile').addClass('selected');
                    $('.js-select-variation[data-product-id="' + currentlySelectedProductID + '"]').addClass('active');
                }

                $('.js-select-variation').off('click').on('click', function () {
                    let $this = $(this);
                    let productId = $this.attr('data-product-id');
                    let vtoId = $this.attr('data-vto-id');
                    let $parent = $this.closest('.rx-product-tile');
                    $parent.find('.js-launch-vto').attr('data-vto-id', vtoId);
                    $parent.find('.js-select-frame').attr('data-product-id', productId);
                    $parent.find('.js-select-frame').click();
                });
                $('.js-select-frame').off('click').on('click', function (event) {
                    event.stopPropagation();
                    let productId = $(this).attr('data-product-id');

                    $('.js-missing-variation-error').addClass('d-none');

                    if (!productId) {
                        let $parent = $(this).closest('.rx-product-tile');
                        $('.js-missing-variation-error', $parent).removeClass('d-none');
                        return;
                    }

                    $('.js-select-variation').removeClass('active');
                    $('.js-select-variation[data-product-id="' + productId + '"]').addClass('active');

                    let $productInfo = $('.js-product-info[data-product-id="' + productId + '"]', $currentSection);
                    let $currentFrame = $productInfo.closest('.rx-product-tile');

                    $cache.frameProductId.val($productInfo.attr('data-product-id') || '');
                    $('input[name="dwfrm_rxForm_productSKU"]').val($productInfo.attr('data-sku') || '');
                    $('input[name="dwfrm_rxForm_productColor"]').val($productInfo.attr('data-color') || '');
                    $('input[name="dwfrm_rxForm_productSize"]').val($productInfo.attr('data-size') || '');
    
                    $nextBtn.removeClass('disabled');
                    $('.customer-frame').html($currentFrame.find('.product-name').html());

                    if ($('.js-select-variation.active', $currentFrame).length) {
                        $('.customer-frame-variation').html($('.js-select-variation.active', $currentFrame).text());
                    } else {
                        $('.customer-frame-variation').html('');
                    }

                    $('.js-frame-result-img').html($currentFrame.find('.image-container').html());
                    $('.rx-product-tile').removeClass('selected');
                    $('.js-error-frame-selection-missing', $currentSection).addClass('d-none');
                    $currentFrame.addClass('selected');
                    if ($(this).attr('data-dismiss') === 'modal') {
                        $vtoModal.modal('hide');
                    }
                    $('.js-frame-result-wrapper').removeClass('d-none');
                    updateFrameBaseWarning($productInfo);
                    $('html, body').animate({
                        scrollTop: $('.js-frame-result-wrapper').offset().top - $('.main-content').css('padding-top').replace('px', '') - 100
                    });
                    checkNextButtonState();
                });

            },
            complete: function () {
                return resolve();
            }
        });
    });
}

/**
 * Init events of section 3 — Upload & Shipping (merged from former section 4)
 * @returns {Promise} promise
 */
function initSection3() {
    return new Promise((resolve, reject) => {
        const SECTION_STEP = 3;
        window.dataLayer.push({
            'RefMonture': $('input[name="dwfrm_rxForm_productSKU"]').val(),
            'Taille': $('input[name="dwfrm_rxForm_productSize"]').val() || 'N/A',
            'Verre': $('input[name="dwfrm_rxForm_lens"]:checked').length > 0 ? $('input[name="dwfrm_rxForm_lens"]:checked').val() : '',
            'event': 'Etape2'
        });
        openSection(SECTION_STEP);
        // Step 3 recap: copy radio labels (pre-checked single options never fire change; deep link to step=3)
        var $section2 = $cache.section2;
        var $checkedPrescription = $('input[name="dwfrm_rxForm_prescriptionType"]:checked', $section2);
        if ($checkedPrescription.length) {
            $('.js-prescription-type-result').html($checkedPrescription.parent().find('label .title').html());
        }
        var $checkedLens = $('input[name="dwfrm_rxForm_lens"]:checked', $section2);
        if ($checkedLens.length) {
            $('.js-lens-result').html($checkedLens.parent().find('label .title').html());
        }
        let $currentSection = $cache.section3;
        let $form = $cache.form;
        let $shippingTypeRadio = $('input[name="dwfrm_rxForm_shippingtype"]', $currentSection);
        let $enduserAddress = $('.js-enduser-address', $currentSection);
        let $homeShippingForm = $('.js-shipping-home-form', $currentSection);
        let $shippingHomeInputs = $('input, select', $homeShippingForm);
        var getShippingTypeVal = function () {
            return $('input[name="dwfrm_rxForm_shippingtype"]:checked', $currentSection).val();
        }
        var handleShippingType = function (preventFocus) {
            if (getShippingTypeVal() === 'home') {
                $homeShippingForm.removeClass('disabled');
                $enduserAddress.addClass('disabled');
                $shippingHomeInputs.prop('disabled', false);
                if (!preventFocus) {
                    $($shippingHomeInputs[0]).focus();
                }
            } else {
                $homeShippingForm.addClass('disabled');
                $enduserAddress.removeClass('disabled');
                $shippingHomeInputs.removeClass('is-invalid').prop('disabled', true);
            }
        };
        $('#dwfrm_rxForm_email').on('input', function() {
            $('#email-guest').val($(this).val());
        });
        $form.off('submit').on('submit', function (e) {
            e.preventDefault();
            $.spinner().start();
            var form = $(this);
            var data = new FormData(form[0]);
            var button = $('.btn-submit-rx-form');
            button.attr('disabled', true);
            $.ajax({
                method: $form.attr('method'),
                url: $form.attr('action'),
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                dataType: 'json',
                timeout: 60000,
                cache: false,
                success: function (data) {
                    if (data.success) {
                        window.dataLayer.push({
                            'Livraison': ($('input[name="dwfrm_rxForm_shippingtype"]:checked').length > 0 && $('input[name="dwfrm_rxForm_shippingtype"]:checked').val() === 'home') ? 'A domicile' : 'En entreprise',
                            'event': 'Etape3'
                        });
                        if (data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        } else {
                            $.spinner().stop();
                        }
                    } else {
                        formValidation($form, Array.isArray(data.error) ? data : Object.assign({}, data, { error: [data.msg] }));
                        button.removeAttr('disabled');

                        if ($('.is-invalid', $form).length) {
                            $('html, body').animate({
                                scrollTop: $($('.is-invalid', $form)[0]).offset().top
                            }, 500);
                        }
                        $.spinner().stop();
                        if (data.error && data.msg) {
                            showErrorMessage(data.msg);
                        }
                    }
                },
                error: function (e) {
                    button.removeAttr('disabled');
                    $.spinner().stop();
                    if (e && e.length) {
                        showErrorMessage(e);
                    }
                }
            });
        });

        $('#dwfrm_rxForm_file').on('change', function (e) {
            var files = e.currentTarget.files;
            var approved = false;
            for (var x in files) {
                var filesize = ((files[x].size / 1024) / 1024).toFixed(4); // MB
                var filename = files[x].name;
                if (typeof filename !== 'undefined') {
                    var fileExtension = filename.substr(filename.lastIndexOf('.') + 1);
                    var autorizedExtension = ['gif', 'heic', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'pdf'];
                    if (files[x].name != 'item' && typeof filename !== 'undefined' && filesize <= 10 && (autorizedExtension.indexOf(fileExtension) > -1)) {
                        approved = true;
                    }
                }
            }
            if (!approved) {
                $(this).val('');
                $(this).next().next().html($(this).attr('data-format-error'))
                    .show();
            } else {
                $(this).next().next().html('')
                    .hide();
            }
        });

        $('.btn-submit-rx-form').on('click', function () {
            let hasFoundInvalid = false;
            $('input, select, textarea', $form).on('invalid', function (e) {
                if (!hasFoundInvalid) {
                    let $input = $(this);
                    $('html, body').animate({
                        scrollTop: $input.offset().top - $('header').outerHeight() - 30
                    }, 500);
                    hasFoundInvalid = true;
                }
            });
        });

        handleShippingType(true);
        $shippingTypeRadio.on('change', function () {
            handleShippingType();
        });
        $homeShippingForm.on('click', function () {
            if (getShippingTypeVal() !== 'home') {
                $('#rx-shipping-home-delivery', $currentSection).prop('checked', true).trigger('change');
            }
        });

        return resolve();
    });
}

/**
 * verify form entries of section 1
 * @returns {Promise} promise
 */
function verifySection1() {
    return new Promise((resolve, reject) => {
        if ($('.js-error-pd-validation:visible').length > 0) {
            return reject('PD validation failed');
        }
        if ($cache.pdResultInput.val()) {
            if ($('.pd-manual-form').is(':visible')) {
                $('.rx-stepper-1').addClass('force-enabled');
                $('.js-back-btn-section1').removeClass('d-none');
            } else {
                $('.js-back-btn-section1').addClass('d-none');
                $('.rx-stepper-1').removeClass('force-enabled');
            }
            return resolve();
        }
        return reject();
    });
}

/**
 * verify form entries of section 2 (prescription type + lens type + frame selection)
 * @returns {Promise} promise
 */
function verifySection2() {
    return new Promise((resolve, reject) => {
        var hasFoundInvalid = false;
        let $currentSection = $cache.section2;

        let $inputsPrescription = $('input[name="dwfrm_rxForm_prescriptionType"]', $currentSection);
        if ($inputsPrescription.length && $inputsPrescription.filter(':checked').length === 0) {
            $inputsPrescription.closest('.custom-radio').addClass('is-invalid');
            hasFoundInvalid = true;
        } else {
            $inputsPrescription.closest('.custom-radio').removeClass('is-invalid');
        }

        let $inputsLens = $('input[name="dwfrm_rxForm_lens"]', $currentSection);
        if ($inputsLens.length && !$('.js-lens-type-section', $currentSection).hasClass('d-none') && $inputsLens.filter(':checked').length === 0) {
            $inputsLens.closest('.custom-radio').addClass('is-invalid');
            hasFoundInvalid = true;
        } else {
            $inputsLens.closest('.custom-radio').removeClass('is-invalid');
        }

        let selectedFrameID = $('input[name="dwfrm_rxForm_productID"]').val();
        if (!selectedFrameID) {
            $('.js-error-frame-selection-missing', $currentSection).removeClass('d-none');
            hasFoundInvalid = true;
        }

        if (hasFoundInvalid) {
            return reject(new Error('Section 2 validation failed'));
        }
        return resolve();
    });
}


let functionNamesMap = {
    verifySection1: verifySection1,
    verifySection2: verifySection2,
    initSection1: initSection1,
    initSection2: initSection2,
    initSection3: initSection3
};

/**
 * Call step function for a given section and a given action
 * @param {string} action - verify|init
 * @param {string} step - given section number
 * @returns {Promise} response
 */
function callSectionFunction(action, step) {
    return functionNamesMap[action + 'Section' + step]();
}

/**
 * Clear error message
 */
function clearErrorMessage() {
    $('.rx-error-message .alert-danger').addClass('d-none');
    $('.rx-error-message:visible .alert-danger .error-message-text').html('');
}
/**
 * Show error message
 * @param {any} e - error
 */
function showErrorMessage(e) {
    $('.rx-error-message:visible .alert-danger').removeClass('d-none');
    $('.rx-error-message:visible .alert-danger .error-message-text').html(e);
}

/**
 * Update a step when the current step has changed
 * @param {number} currentStep - current  step
 */
async function updateStep(currentStep) {
    $cache.form.attr('data-current-step', currentStep);
    await callSectionFunction('init', currentStep);
    setTimeout(function () {
        $('.rx-form-section:not(.active)').hide();
    }, 400);
}

/**
 * Handle tabs activation
 * @param {number} currentStep - current  step
 */
function handleNavigation(currentStep) {
    $cache.nav.find('.step').removeClass('active disabled completed');
    $cache.nav.find('.step .rx-nav-link').removeAttr('disabled');

    // Always disable step 0
    $cache.nav.find('.rx-stepper-0').addClass('disabled');
    $cache.nav.find('.rx-stepper-0 .rx-nav-link').attr('disabled', 'disabled');

    // Step 1 keeps the disabled class for visual appearance but can be active or completed
    if (currentStep > 1) {
        // If current step is beyond 1, step 1 can be marked as completed visually
        $cache.nav.find('.rx-stepper-1').addClass('completed');
    }

    $cache.nav.find('.rx-stepper-' + currentStep).addClass('active');
    if (currentStep === 1) {
        // Ensure step 1 is visually disabled even if it's the current step
        $cache.nav.find('.rx-stepper-1 .rx-nav-link').attr('disabled', 'disabled');
    }

    for (let i = 0; i < currentStep; i += 1) {
        if (i !== 0) { // Skip step 0 as it's always disabled
            $cache.nav.find('.rx-stepper-' + i).addClass('completed');
        }
    }

    for (let i = currentStep + 1; i <= NB_STAGES; i += 1) {
        if (i !== 1) { // Apply disabled status to steps beyond the current one, excluding step 1's special handling
            $cache.nav.find('.rx-stepper-' + i).addClass('disabled');
            $cache.nav.find('.rx-stepper-' + i + ' .rx-nav-link').attr('disabled', 'disabled');
        }
    }

    // Ensure step 1 visually appears disabled regardless of its state
    if (!$cache.nav.find('.rx-stepper-1').hasClass('force-enabled')) {
        $cache.nav.find('.rx-stepper-1').addClass('disabled');
    }
}


/**
 * pre-init VTO for perf issue
 */
function preloadVTO() {
    var params = {
        apiKey: $cache.vtoWidget.attr('data-api-key'),
        onStopVto: () => true,
        dataPrivacyDisclaimerTexts: JSON.parse($cache.vtoWidget.attr('data-privacy-config') || {})
    };
    window.fitmixInstance = FitMix.createWidget('VTOWidget', params, function () {});
}

module.exports = {
    init: async function init() {
        window.dataLayer = window.dataLayer || [];
        dynamicModal.init();

        var currentStep = $cache.form.attr('data-current-step');
        $('.rx-form-section:not(.active)').hide();
        await callSectionFunction('init', currentStep);
        preloadVTO();

        /** START: navigation listeners and history */
        $('.js-next-btn', $cache.sections).on('click', async function handleClick() {
            let currentSection = $(this).closest('.rx-form-section').attr('data-step');
            let nextSection = $(this).attr('data-next-step');
            let isJumpStep = $(this).attr('data-is-jump-step') === 'true';

            try {
                if (!isJumpStep) {
                    await callSectionFunction('verify', currentSection);
                }
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'instant'
                });
                clearErrorMessage();
                currentStep = nextSection;
                // Add Current Step in param
                history.pushState(
                    nextSection,
                    document.title,
                    location.pathname
                    + '?step='
                    + nextSection
                );
                await updateStep(nextSection);
            } catch (e) {
                console.log('ERROR ON VERIFY SECTION', e);
                clearErrorMessage();
                if (e && e.length > 0) {
                    showErrorMessage(e);
                }
            }
        });

        $($cache.form).on('keypress', async function (e) {
            if (e.which === 13) {
                e.preventDefault();
                $('.js-next-btn:visible', $cache.sections).trigger('click');
            }
        });
        
        $('.rx-stepper .step').on('click', async function(e) {
            e.preventDefault();
            if(!$(this).hasClass('disabled') && $(this).hasClass('completed')) {
                var requestedStep = $(this).find('.rx-nav-link').attr('data-step');
                await updateStep(requestedStep);
                history.pushState(
                    requestedStep,
                    document.title,
                    location.pathname
                    + '?step='
                    + requestedStep
                );

                if ($('.rx-stepper-1.active').length > 0) {
                    $('.js-pd-pane-sub-section[data-sub-step="1"]', $('.rx-form-section[data-step="1"]')).removeClass('d-none');
                    $('.rx-stepper-1').removeClass('force-enabled').addClass('disabled');
                }
            }
        });

        // Handle Previous and next button
        $(window).on('popstate', async function () {
            var url = window.location.href;
            var match = url.match(/[\?&]step=([^&#]*)/);
            if (match) {
                currentStep = match[1];
            } else {
                currentStep = 0;
            }
            await updateStep(currentStep);
            preloadVTO();
        });

        /** END: navigation listeners and history */
        function getQueryParam(param) {
            return new URLSearchParams(window.location.search).get(param);
        }
        function updateUrlParameter(param, value) {
            var currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set(param, value);
            window.history.replaceState({}, '', currentUrl);
        }

        var currentStep = $cache.form.attr('data-current-step');
        var urlStep = getQueryParam('step');
        if (currentStep !== urlStep) {
            updateUrlParameter('step', currentStep);
        }

        /** START: Help section events */
        $cache.helpBtn.on('click', function () {
            $cache.helpSection.toggleClass('active');

            let $content = $('.content', $cache.helpSection);
            if ($cache.helpSection.hasClass('active') && !$content.html()) {
                $.ajax({
                    method: 'get',
                    url: $(this).attr('data-url'),
                    success: function (contentHtml) {
                        $content.html(contentHtml);
                    }
                });
            }
            if ($cache.helpSection.hasClass('active')) {
                window.dataLayer.push({
                    'etape': 'Etape' + currentStep,
                    'event': 'DemandeAide'
                });
            }
        });
        /** END: Help section events */

    }
};
